



























































































































































import { Component,Prop, Vue } from 'vue-property-decorator';
import { Campaign, CampaignCall, CampaignTopStats } from '@/data/models/campaign.model';
import { Headquarter } from '@/data/models/headquarter.model';

@Component
export default class CallCenter extends Vue {
	@Prop() campaign!: Campaign;
	@Prop() headquarter!: Headquarter;
	@Prop() calls!: CampaignCall[];
	@Prop() stats!: CampaignTopStats[];
}
